import { GetCountries, GetCountriesToken } from "$src/application/map/queries/GetCountries";
import { Country } from "$src/domain/map/Country";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchCountries(languageCode: string): Promise<Country[]> {
    const query = container.resolve<GetCountries>(GetCountriesToken);
    return query.execute(languageCode);
}

export function useCountries(languageCode: string) {
    return useQuery<Country[], Error>({
        queryKey: ['countries', languageCode],
        queryFn: () => fetchCountries(languageCode),
        staleTime: Infinity,
        cacheTime: 600000,
    });
}